import { render, staticRenderFns } from "./CardChartRadar.vue?vue&type=template&id=055ff4f2&scoped=true&"
import script from "./CardChartRadar.vue?vue&type=script&lang=js&"
export * from "./CardChartRadar.vue?vue&type=script&lang=js&"
import style0 from "./CardChartRadar.vue?vue&type=style&index=0&id=055ff4f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ff4f2",
  null
  
)

export default component.exports